import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { CUSTOMER_COLORS, customerPageSubtitleSx, customerPageTitleSx } from '../../constants/customerTheme';

const CustomerPageHeader = ({ title, subtitle, action, icon: Icon }) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    justifyContent="space-between"
    alignItems={{ xs: 'stretch', sm: 'center' }}
    spacing={2}
    sx={{ mb: 3 }}
  >
    <Box>
      <Typography
        component="h1"
        sx={{
          ...customerPageTitleSx,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        {Icon ? <Icon sx={{ fontSize: 26, color: CUSTOMER_COLORS.primary }} /> : null}
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="body2" color="text.secondary" sx={customerPageSubtitleSx}>
          {subtitle}
        </Typography>
      ) : null}
    </Box>
    {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
  </Stack>
);

export default CustomerPageHeader;
